export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const PAGE_CAPACITY = 13;
export const KEY = '757ac58c-9020-472f-97b9-a7f553500647';
export const MODAL_CLOSE_SEC = 2.5;
